import React from "react";
import ImageGallery from "../components/ImageGallery";

function SportPage() {
  return <ImageGallery category="sport" />;
}

export default SportPage;
